import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const HrisIntegrationRoute = lazyWithRetries(() => import('./'))
const AutoInviteRulesRoute = lazyWithRetries(() => import('./autoInviteRules'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.hrisIntegrations(':tab'),
    element: (
      <StandardPageLayout
        elementId="hrisIntegrationsRoute"
        title={<T _str="HRIS integration" />}
        maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <HrisIntegrationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.autoInviteRules(),
    element: (
      <StandardPageLayout
        elementId="autoInviteRulesRoute"
        title={<T _str="Configure auto invite rules" />}
        maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <AutoInviteRulesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
